var map = {
	"./template.bet575": 2057,
	"./template.bet575.tsx": 2057,
	"./template.bet777": 2058,
	"./template.bet777.tsx": 2058,
	"./template.betblast": 2059,
	"./template.betblast.tsx": 2059,
	"./template.betprofessor": 2060,
	"./template.betprofessor.tsx": 2060,
	"./template.betroyale": 2061,
	"./template.betroyale.tsx": 2061,
	"./template.betstride": 2062,
	"./template.betstride.tsx": 2062,
	"./template.buffalobet": 2063,
	"./template.buffalobet.tsx": 2063,
	"./template.chromabet": 2064,
	"./template.chromabet.tsx": 2064,
	"./template.default": 670,
	"./template.default.tsx": 670,
	"./template.fiestabet": 2065,
	"./template.fiestabet.tsx": 2065,
	"./template.forsport": 1623,
	"./template.forsport.tsx": 1623,
	"./template.gigabet": 2066,
	"./template.gigabet.tsx": 2066,
	"./template.goldenbet888": 2067,
	"./template.goldenbet888.tsx": 2067,
	"./template.goldenrush": 2068,
	"./template.goldenrush.tsx": 2068,
	"./template.hyperbet": 2069,
	"./template.hyperbet.tsx": 2069,
	"./template.juicybet": 2070,
	"./template.juicybet.tsx": 2070,
	"./template.junglebet": 2071,
	"./template.junglebet.tsx": 2071,
	"./template.magnumbet": 2072,
	"./template.magnumbet.tsx": 2072,
	"./template.oldgill": 2073,
	"./template.oldgill.tsx": 2073,
	"./template.puntcity": 2074,
	"./template.puntcity.tsx": 2074,
	"./template.puntgenie": 2075,
	"./template.puntgenie.tsx": 2075,
	"./template.pyramidbet": 2076,
	"./template.pyramidbet.tsx": 2076,
	"./template.questbet": 2077,
	"./template.questbet.tsx": 2077,
	"./template.slambet": 2078,
	"./template.slambet.tsx": 2078,
	"./template.sterlingparker": 2079,
	"./template.sterlingparker.tsx": 2079,
	"./template.sugarcastle": 2080,
	"./template.sugarcastle.tsx": 2080,
	"./template.templebet": 2081,
	"./template.templebet.tsx": 2081,
	"./template.titanbet": 2082,
	"./template.titanbet.tsx": 2082,
	"./template.ts": 984,
	"./template.vikingbet": 2083,
	"./template.vikingbet.tsx": 2083,
	"./template.volcanobet": 2084,
	"./template.volcanobet.tsx": 2084,
	"./template.wellbet": 2085,
	"./template.wellbet.tsx": 2085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2459;